@if (spriteUrl && name) {
  <svg>
    <use [attr.xlink:href]="spriteUrl + '#' + name"></use>
  </svg>
}
